// extracted by mini-css-extract-plugin
export var messageSideLeft = "_sj-1";
export var stateContainer = "_sj-0";